import React, { forwardRef } from 'react';

const CallRemoteAudio = forwardRef(function CallRemoteAudio({ muted }, ref) {
  return (
    <audio
      ref={ref}
      autoPlay
      playsInline
      preload="auto"
      muted={muted}
      aria-hidden="true"
      style={{
        position: 'absolute',
        width: 1,
        height: 1,
        opacity: 0,
        pointerEvents: 'none',
        left: -9999,
        top: -9999,
      }}
    />
  );
});

export default CallRemoteAudio;
